<template>  
<div> <!-- root element start -->
	<div class="row">
		<div class="col-12">
			<div class="card border-0">
			    <div class="card-header h5 bg-transparent border-0">Create a Contact</div>
          <div class="card-body">

            <div v-if="allowOrg == 0" class="row d-flex align-items-center mb-3">
              <div class="col-12 col-lg-2">
                <small>Organization</small>
              </div>
              <div class="col-12 col-lg-8">
                <div v-if="orgListLoad == '0'" class="col-12 d-flex align-items-center justify-content-center">
                  <spring-spinner :animation-duration="2000" :size="25" color="#0E1698"/><span class="ml-2">Loading Organizations</span>
                </div>
                <select  v-if="orgListLoad == '1'" type="text" class="form-control" id="orgname" v-model="org_id">
                  <option value="n">Select an Organization</option>
                  <option value="1">Unassigned</option>
                  <option v-for="(org, index) in orgList" :value="org.id">{{ org.name }}</option>
                </select>
              </div>


            </div>
    

            <div class="row d-flex align-items-center mb-3">
              <div class="col-12 col-lg-2">
                <small>Name</small>
              </div>

              <div class="col-12 col-lg-5">                
                <input type="text" class="form-control" id="firstname" placeholder="First Name" v-model="f_name">
              </div>

              <div class="col-12 col-lg-5">
                <input type="text" class="form-control" id="lastname" placeholder="Last Name" v-model="l_name">  
              </div>
            </div>

            <div class="row d-flex align-items-center mb-2">
              <div class="col-12 col-lg-2">
                <small>Primary Email</small>
              </div>
              <div class="col-12 col-lg-6">
                <input type="email" class="form-control" id="pri_email" placeholder="Primary Email" v-model="pri_email">
              </div>
            </div>


            <div class="row d-flex align-items-center mb-2">
              <div class="col-12 col-lg-2">
                <small>Primary Phone</small>
              </div>
              
              <div class="col-12 col-lg-6">
                <VuePhoneNumberInput v-model="pri_phone"
                    default-country-code="US"
                    no-country-selector
                    no-validator-state
                  />
              </div>
              
            </div>

            
            <hr class="mt-3">
            <div class="row ">
              <div class="col-12">
                <button class="btn btn-warning" @click="cancelContact">Cancel</button>
                <button class="btn btn-success" @click="submitContact">Save Contact</button>
              </div>
            </div>

          </div>
			</div>
		</div>
	</div>
</div> <!-- root element end -->
</template>


<script>
import { SpringSpinner } from 'epic-spinners'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';



export default {
  props: ['prop1', 'prop2', 'prop3'],
  data: function () {
    return { 
      allowOrg: 0,
      orgList: [],
      orgListLoad: '0',
      f_name: '',
      l_name: '',
      org_id: 'n',
      pri_email: '',
      pri_phone: '',
    }
  },
  computed: {

  },
  watch: {
    
  },
  mounted() {
    this.onOpen();
    this.getOrgList();
  },
  methods: {
    changeRightView(name, prop1, prop2, prop3) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2, prop3: prop3 }); },

    onOpen() {
      var _this = this;
      if(typeof _this.prop3[2] === 'undefined') {
          // does not exist
      }
      else {
          _this.allowOrg = 1;
          _this.org_id = _this.prop3[2]
      }
    },

    getOrgList () {
      var _this = this;
      _this.orgListLoad = '0';
      axios.get('/utility/user/org/getallorgsbyuser')
        .then(function (response) {
          var a = response.data.data;
          _this.orgList = a;
          _this.orgListLoad = '1';
        })
        .catch(function (error) {
          var errors = error.response.data.errors;
          _this.errorDisplay(errors);
        })
    },


    

    submitContact(){
      var _this = this;
      _this.$toastr.warning('Validating contact information.', 'Please wait!')
      //validate with js
      var valErrors = [];


    

      //validate org
      if(_this.org_id == '' || _this.org_id == null || _this.org_id == 'n') { valErrors.push('A valid organization, or "unassigned", is required!') }
      //validate first name
      if(_this.f_name == '' || _this.f_name == null) { valErrors.push("A first name is required!") }
      //validate last name
      if(_this.l_name == '' || _this.l_name == null) { valErrors.push("A last name is required!") }
      if(_this.l_name.length <= 2 ) { valErrors.push("A last name requires more than two letters!") }
      //validate email
      var mailformat = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
      if(_this.pri_email == '' || _this.pri_email == null) { 
        valErrors.push("The primary email address is required!") 
      } else if (!_this.pri_email.match(mailformat)) {
        valErrors.push("The primary email address you entered is not valid!") 
      }
      var phoneFormat = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
      if(_this.pri_phone != '' && _this.pri_phone != null) {
        if(!_this.pri_phone.match(phoneFormat)) { valErrors.push("The primary phone number you entered is invalid!") }  
      }

      if(valErrors.length > 0) {
        _this.$toastr.remove();
        _this.errorDisplay(valErrors);
        return false;
      } 

      _this.$toastr.remove()

      _this.$toastr.warning('Saving new contact information.', 'Please wait!')
      axios.post('/utility/all/contact/storecontact', {
        org_id: _this.org_id,
        f_name: _this.f_name,
        l_name: _this.l_name,
        pri_email: _this.pri_email,
        pri_phone: _this.pri_phone,

      })
        .then(function (response) {
          var msg = response.data.msg;
          _this.$toastr.remove()
          _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
          _this.$emit('onSComplete', ['contact-add', response.data.newid])
        })
        .catch(function (error) {
          var errors = error.response.data.errors;
          _this.errorDisplay(errors);
        })

      
    },
    cancelContact() {
      var _this = this;
      _this.$emit('onUComplete', ['contact-add'])
    },
    errorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    },

  },    
  components:{
    SpringSpinner,
    VuePhoneNumberInput,
    
  },
  filters: {

  }
}
</script>

